// Shared helpers for rendering search hits.
//
// The backend returns plain-text snippets/excerpts; we add highlighting on the
// client by wrapping matches in <mark>. Anything injected via
// dangerouslySetInnerHTML downstream MUST go through `highlightMatches` (which
// HTML-escapes first) — never raw user content.

export const escapeRegExp = (value: string): string =>
    value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const escapeHtml = (value: string): string =>
    value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/**
 * HTML-escape `text`, then wrap case-insensitive matches of `query` in <mark>.
 * Returns escaped (safe) HTML. An empty/whitespace-only query returns the
 * text escaped but unmarked.
 */
export const highlightMatches = (text: string, query: string | null | undefined): string => {
    const escaped = escapeHtml(text);
    const trimmed = (query ?? '').trim();
    if (!trimmed) return escaped;
    const regex = new RegExp(`(${escapeRegExp(trimmed)})`, 'ig');
    return escaped.replace(regex, '<mark>$1</mark>');
};
